import React from 'react';
import { useTranslations } from 'next-intl';
import { Grid2, Box } from '@mui/material';

const CountryTitle: React.FC = () => {
  const t = useTranslations('Home');
  return (
    <Grid2 pt={{ xs: 4, md: 8 }} size={12} container data-aos="fade-up">
      <Grid2
        size={12}
        sx={{
          fontSize: {
            xs: '32px',
            md: '40px',
          },
          fontWeight: 700,
          lineHeight: 'normal',
          color: '#000',
          textAlign: 'center',
        }}
      >
        {t('caseShareTitle')}
      </Grid2>
      <Grid2
        size={12}
        sx={{
          fontSize: '20px',
          fontWeight: 400,
          lineHeight: 'normal',
          color: '#333',
          textAlign: 'center',
        }}
        pt={3}
      >
        {t('caseShareDescription')}
      </Grid2>
    </Grid2>
  );
};

export default CountryTitle;
